import {
  DefaultThumbnailLiveStream,
  DemoHomepageIntroductionBanner,
  DemoVideoThumbail,
} from '@/constant/imgImport';
import {
  EHomepageTabSectionKey,
  TEnterpriseProfileHomepageTabSection,
} from '@/interfaces/enterprise-profile/homepage_tab.interface';

export const iniTialVideo = {
  thumbnail: DemoVideoThumbail,
  title: 'Một ngày tại trường Đại học Y dược TPHCM',
  content:
    'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên).',
  videoUrl: 'https://www.dofactory.com/media/movie.mp4',
  createdAt: new Date().toISOString(),
};

export const hashHomepageSectionName = {
  [EHomepageTabSectionKey.Introduction]: 'Giới thiệu',
  [EHomepageTabSectionKey.Events]: 'Sự kiện nổi bật',
  [EHomepageTabSectionKey.MaybeYouKnow]: 'Có thể bạn biết',
  [EHomepageTabSectionKey.SuggestedCourses]: 'Khoá học được đề xuất',
  [EHomepageTabSectionKey.HighlightCourses]: 'Khoá học nổi bật',
  [EHomepageTabSectionKey.HighlightVideos]: 'Video nổi bật',
  [EHomepageTabSectionKey.Footer]: 'Footer',
  [EHomepageTabSectionKey.FeaturedTopics]: 'Chuyên đề nổi bật',
  [EHomepageTabSectionKey.NavigateButton]: 'NavigateButton',
  [EHomepageTabSectionKey.Custom1]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom2]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom3]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom4]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom5]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom6]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom7]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom8]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom9]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.Custom10]: 'Tuỳ chỉnh',
  [EHomepageTabSectionKey.LiveStream]: 'Phát trực tiếp',
};

export const defaultHomepageSection: TEnterpriseProfileHomepageTabSection = [
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Introduction],
    sectionKey: EHomepageTabSectionKey.Introduction,
    elements: {
      title: 'Trường đại học Y Dược thành phố Hồ Chí Minh',
      content:
        'Được thành lập từ năm 1947, trường đã dìu đắt, đào tạo và cung cấp cho nhân lực Quốc gia hàng triệu bác sĩ với hy vọng và mong muốn chữa bệnh.',
      image: '/banner/yds.png',
      videoUrl: '',
      thumbnail: '/banner/yds.png',
      isUploadVideo: false,
      titleColor: '#009CE0',
    },
    isActive: true,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Events],
    sectionKey: EHomepageTabSectionKey.Events,
    elements: {
      banners: [],
      links: [],
    },
    isActive: true,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.MaybeYouKnow],
    sectionKey: EHomepageTabSectionKey.MaybeYouKnow,
    isActive: true,
  },
  {
    sectionName:
      hashHomepageSectionName[EHomepageTabSectionKey.SuggestedCourses],
    sectionKey: EHomepageTabSectionKey.SuggestedCourses,
    elements: {
      courses: [],
    },
    isActive: true,
  },
  {
    sectionName:
      hashHomepageSectionName[EHomepageTabSectionKey.HighlightCourses],
    sectionKey: EHomepageTabSectionKey.HighlightCourses,
    isActive: true,
  },
  {
    sectionName:
      hashHomepageSectionName[EHomepageTabSectionKey.HighlightVideos],
    sectionKey: EHomepageTabSectionKey.HighlightVideos,
    elements: {
      videos: [iniTialVideo],
    },
    isActive: true,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Footer],
    sectionKey: EHomepageTabSectionKey.Footer,
    elements: {
      logoUrl: '/img/homepage/header-logo.svg',
      footerContent: [
        {
          title: 'Giới thiệu',
          links: [
            {
              title: 'Giới thiệu',
              url: '/',
            },
          ],
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.FeaturedTopics],
    sectionKey: EHomepageTabSectionKey.FeaturedTopics,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.NavigateButton],
    sectionKey: EHomepageTabSectionKey.NavigateButton,
    elements: {
      navigate: {
        title: 'Doccen',
        url: 'https://www.doccen.vn/feed',
      },
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom1],
    sectionKey: EHomepageTabSectionKey.Custom1,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom2],
    sectionKey: EHomepageTabSectionKey.Custom2,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom3],
    sectionKey: EHomepageTabSectionKey.Custom3,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom4],
    sectionKey: EHomepageTabSectionKey.Custom4,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom5],
    sectionKey: EHomepageTabSectionKey.Custom5,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom6],
    sectionKey: EHomepageTabSectionKey.Custom6,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom7],
    sectionKey: EHomepageTabSectionKey.Custom7,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom8],
    sectionKey: EHomepageTabSectionKey.Custom8,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom9],
    sectionKey: EHomepageTabSectionKey.Custom9,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.Custom10],
    sectionKey: EHomepageTabSectionKey.Custom10,
    elements: {
      topics: [
        {
          id: Math.random().toString(),
          image: DemoHomepageIntroductionBanner,
          title: 'Khoa học máy tính',
          url: '',
        },
      ],
    },
    isActive: false,
  },
  {
    sectionName: hashHomepageSectionName[EHomepageTabSectionKey.LiveStream],
    sectionKey: EHomepageTabSectionKey.LiveStream,
    elements: {
      title: 'Một ngày tại trường Đại học Y dược TPHCM',
      content:
        'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên). Đây là các thông tin mà Doccen.vn cần thành viên cung cấp bắt buộc khi đăng ký sử dụng dịch vụ để Doccen.vn liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ trên website ',
      startTime: {
        date: new Date().toISOString().split('T')[0],
        hours: 7,
        minutes: '00',
      },
      optionButton: {
        title: 'Xem trực tiếp',
        link: 'https://www.doccen.vn/feed',
        enable: true,
      },
      thumbnail: DefaultThumbnailLiveStream,
      liveStreamUrl: '',
    },
    isActive: false,
  },
];
